var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSimVertical = function SvgSimVertical(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9947 1.3335L6.73474 7.7239L6.73474 29.9651L25.2611 29.9651L25.2611 1.3335L12.9947 1.3335Z",
    fill: "#B8AEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0506 12.7123V25.3229C21.0506 25.5614 20.8625 25.7544 20.6322 25.7544H11.3636C11.1329 25.7544 10.9453 25.5614 10.9453 25.3229L10.9453 12.7123C10.9453 12.4738 11.1329 12.2808 11.3636 12.2808L20.6322 12.2808C20.8625 12.2808 21.0506 12.4738 21.0506 12.7123Z",
    fill: "#E7E2FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSimVertical);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi45OTQ3IDEuMzMzNUw2LjczNDc0IDcuNzIzOUw2LjczNDc0IDI5Ljk2NTFMMjUuMjYxMSAyOS45NjUxTDI1LjI2MTEgMS4zMzM1TDEyLjk5NDcgMS4zMzM1WiIgZmlsbD0iI0I4QUVGMSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxLjA1MDYgMTIuNzEyM1YyNS4zMjI5QzIxLjA1MDYgMjUuNTYxNCAyMC44NjI1IDI1Ljc1NDQgMjAuNjMyMiAyNS43NTQ0SDExLjM2MzZDMTEuMTMyOSAyNS43NTQ0IDEwLjk0NTMgMjUuNTYxNCAxMC45NDUzIDI1LjMyMjlMMTAuOTQ1MyAxMi43MTIzQzEwLjk0NTMgMTIuNDczOCAxMS4xMzI5IDEyLjI4MDggMTEuMzYzNiAxMi4yODA4TDIwLjYzMjIgMTIuMjgwOEMyMC44NjI1IDEyLjI4MDggMjEuMDUwNiAxMi40NzM4IDIxLjA1MDYgMTIuNzEyM1oiIGZpbGw9IiNFN0UyRkYiLz4KPC9zdmc+Cg==";